import { render, staticRenderFns } from "./ImportTjb.vue?vue&type=template&id=3c009338&scoped=true"
import script from "./ImportTjb.vue?vue&type=script&lang=js"
export * from "./ImportTjb.vue?vue&type=script&lang=js"
import style0 from "./ImportTjb.vue?vue&type=style&index=0&id=3c009338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c009338",
  null
  
)

export default component.exports